// import * as classes from './App.scss';
import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { store } from '..';
import { hot } from 'react-hot-loader';

// import { BaseService } from '@services/BaseService';

import { AuthRedirect, Login } from '../auth';
import { Layout } from '../layout/layout';
import DashboardComponent from '../dashboard/dashboard';
import { NotFoundComponent } from '@common/components';
import { Version } from '../version';
import TableOfContents from '../table-of-contents/table-of-contents';
import { config } from '@common/config';
import { RouteDefinitions } from '@common/route-definitions';
import { Role, Roles } from '@models/Roles';

import { CILNotification } from '../cil-notification';
import { AutoAutho } from '../auto-autho';
import { QuoteSearch } from '../quote/_components/quote-search/quote-search.container';
import { VendorDetails } from '../vendor/_components/vendor-details/vendor-details.container';
import { VendorTradeMaintenance } from '../vendor/_components/vendor-trade-maintenance/vendor-trade-maintenance.container';

import { resetContract, cloneContract } from '../contract/contract.actions';

// TODO: SOME COMPONENTS CAN GO INTO EXISTING OR FUTURE MODULES
import { AccountingList } from '../accounting/_components/accounting-list/accounting-list.container';
import { AuthRoute } from '@common/components';
import { convertQuotePreventReset } from '../quote/quote.actions';

import { VendorCreate } from 'src/vendor/_components/flows/vendor-create/vendor-create.container';
import { VendorEdit } from 'src/vendor/_components/flows/vendor-edit/vendor-edit.container';

import { Help } from 'src/help/help.component';

import { AutoAuthoTutorial } from 'src/tutorial/autoauthotutorial.component';

// Async Components from _Modules
import {
  AsyncContract,
  AsyncContractDetails,
  AsyncContractCancellation,
  AsyncContractNoRenew,
  AsyncContractTransfer,
  AsyncRenewalNoChanges,
  AsyncRenewalWithChanges,
  AsyncQuote,
  AsyncQuoteDetails,
  AsyncOrderEdit,
  AsyncContract2,
  AsyncContractEmail,
  AsyncPaymentEdit,
  AsyncContractBalances
} from '../_Modules/contract.module';

import {
  AsyncRealEstateAgentSearch,
  AsyncRealEstateAgent,
  AsyncRealEstateAgentDetails,
  AsyncRealEstateOfficeSearch,
  AsyncRealEstateOfficeDetails,
  AsyncRealEstateOffice
} from '../_Modules/realestate.module';

import {
  AsyncEscrowOfficerSearch,
  AsyncEscrowOfficer,
  AsyncEscrowOfficerDetails,
  AsyncEscrowOfficeSearch,
  AsyncEscrowOffice,
  AsyncEscrowOfficeDetails,
  AsyncTransactionCoordinatorSearch,
  AsyncTransactionCoordinator,
  AsyncTransactionCoordinatorDetails
} from '../_Modules/escrow.module';

import {
  AsyncPropertyManager,
  AsyncPropertyManagerSearch,
  AsyncPropertyManagerDetails,
  AsyncPropertyManagementOffice,
  AsyncPropertyManagementOfficeSearch,
  AsyncPropertyManagementOfficeDetails
} from '../_Modules/property-mgmt.module';

import {
  AsyncServiceWorkOrder,
  AsyncServiceWorkOrderSearch,
  AsyncServiceWorkOrderDetails,
  AsyncDispatchLanding,
  AsyncZeroVendorLanding
} from '../_Modules/swo.module';

import {
  AsyncProfile,
  AsyncUser,
  AsyncUsers,
  AsyncCustomer,
  AsyncCustomerSearch,
  AsyncCustomerDetails
} from '../_Modules/user-customer.module';

import {
  AsyncAuthorizationSearch,
  AsyncAuthorizationDetails,
  AsyncAuthorizationManageInventory,
  AsyncInvoicingSearch,
  AsyncInvoiceCreate,
  AsyncInvoiceHeaderCreate,
  AsyncInvoiceDetails,
  AsyncPurchasingSearch,
  AsyncPurchasingDetails
} from '../_Modules/auth-invoice.module';

import { AsyncCilOfferSearch } from '../_Modules/cil-offer.module';

// import { DocTitleComponent } from './DocTitle';
import { TitleRoute } from './TitleRoute';
import { DocTitleComponent } from './DocTitle';
import { SWOStatusTutorial } from '../tutorial/swostatustutorial.component';
import { AsyncTransactionLanding } from 'src/_Modules/transaction.module';
import { ServiceFeePayment } from 'src/service-work-order/_components/service-work-order-create/service-fee-payment-step/service-fee-payment.container';
import { ContractSearch } from 'src/contract/_components/contract-search/contract-search.container';
import { VendorDashboard } from 'src/vendor/_components/vendor-dashboard/_components/vendor-dashboard.container';
import { BaseService } from '@services/BaseService';
import ContractErrorComponent from 'src/contract-error/_components/contract-error';
import { RenewalOptions } from 'src/renewal';

class App extends React.Component {
  render() {
    if (BaseService.hasProfile() && Role.GetUserRoles() && Role.GetUserRoles()!.length > 0) {
      return (
        <div>
          <TitleRoute path={RouteDefinitions.root} component={AuthRedirect} />
          <Layout>
            <Route
              render={({ location }) => (
                <TransitionGroup>
                  <CSSTransition key={location.key} classNames="fade" timeout={350}>
                    <Switch location={location}>
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.root}
                        component={DashboardComponent}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.login}
                        component={DashboardComponent}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.dashboard}
                        component={DashboardComponent}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.onlineToDo}
                        component={ContractErrorComponent}
                      />
                      <TitleRoute
                        allowedRoles={[
                          Roles.Admin,
                          ...Role.GetAllIBS(),
                          ...Role.GetAllAccounting(),
                          Roles.ServiceManager,
                          Roles.ServiceAdmin
                        ]}
                        exact={true}
                        title={RouteDefinitions.customer.Title}
                        path={RouteDefinitions.customer.Edit}
                        component={AsyncCustomer}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        title={RouteDefinitions.customer.Title}
                        path={RouteDefinitions.customer.Search}
                        component={AsyncCustomerSearch}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        title={RouteDefinitions.customer.Title}
                        path={RouteDefinitions.customer.Details}
                        component={AsyncCustomerDetails}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.escrowofficer.Search}
                        component={AsyncEscrowOfficerSearch}
                        title={RouteDefinitions.escrowofficer.Title}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.escrowofficer.Details}
                        title={RouteDefinitions.escrowofficer.Title}
                        component={AsyncEscrowOfficerDetails}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllIBS()]}
                        exact={true}
                        path={RouteDefinitions.escrowofficer.Edit}
                        title={RouteDefinitions.escrowofficer.Title}
                        component={AsyncEscrowOfficer}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.escrowoffice.Search}
                        title={RouteDefinitions.escrowoffice.Title}
                        component={AsyncEscrowOfficeSearch}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.escrowoffice.Details}
                        title={RouteDefinitions.escrowoffice.Title}
                        component={AsyncEscrowOfficeDetails}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllIBS()]}
                        exact={true}
                        path={RouteDefinitions.escrowoffice.Edit}
                        title={RouteDefinitions.escrowoffice.Title}
                        component={AsyncEscrowOffice}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.profile.Edit}
                        title={RouteDefinitions.profile.Title}
                        component={AsyncProfile}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllIBS()]}
                        exact={true}
                        path={RouteDefinitions.propertymanager.Edit}
                        title={RouteDefinitions.propertymanager.Title}
                        component={AsyncPropertyManager}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.propertymanager.Search}
                        title={RouteDefinitions.propertymanager.Title}
                        component={AsyncPropertyManagerSearch}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.propertymanager.Details}
                        title={RouteDefinitions.propertymanager.Title}
                        component={AsyncPropertyManagerDetails}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllIBS()]}
                        exact={true}
                        path={RouteDefinitions.realestateagent.Edit}
                        title={RouteDefinitions.realestateagent.Title}
                        component={AsyncRealEstateAgent}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.realestateagent.Search}
                        title={RouteDefinitions.realestateagent.Title}
                        component={AsyncRealEstateAgentSearch}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.realestateagent.Details}
                        title={RouteDefinitions.realestateagent.Title}
                        component={AsyncRealEstateAgentDetails}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.realestateoffice.Search}
                        title={RouteDefinitions.realestateoffice.Title}
                        component={AsyncRealEstateOfficeSearch}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.realestateoffice.Details}
                        title={RouteDefinitions.realestateoffice.Title}
                        component={AsyncRealEstateOfficeDetails}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllIBS()]}
                        exact={true}
                        path={RouteDefinitions.realestateoffice.Edit}
                        title={RouteDefinitions.realestateoffice.Title}
                        component={AsyncRealEstateOffice}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.transactioncoordinator.Search}
                        title={RouteDefinitions.transactioncoordinator.Title}
                        component={AsyncTransactionCoordinatorSearch}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.transactioncoordinator.Details}
                        title={RouteDefinitions.transactioncoordinator.Title}
                        component={AsyncTransactionCoordinatorDetails}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllIBS()]}
                        exact={true}
                        path={RouteDefinitions.transactioncoordinator.Edit}
                        title={RouteDefinitions.transactioncoordinator.Title}
                        component={AsyncTransactionCoordinator}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllIBS()]}
                        exact={true}
                        path={RouteDefinitions.user.Edit}
                        title={RouteDefinitions.user.Title}
                        component={AsyncUser}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.user.List}
                        title={RouteDefinitions.user.Title}
                        component={AsyncUsers}
                      />
                      <AuthRoute
                        exact={true}
                        allowedRoles={[Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting()]}
                        path={RouteDefinitions.contract.Create}
                        render={props => {
                          return (
                            <DocTitleComponent title={RouteDefinitions.contract.Title}>
                              <AsyncContract
                                resetContract={(clearPropertyInfo: boolean) =>
                                  store.dispatch(resetContract(clearPropertyInfo))
                                }
                                loadContractInfo={(contractId: number | string) => {
                                  store.dispatch(cloneContract(contractId));
                                }}
                                history={props.history}
                                preventReset={store.getState().quote.preventReset}
                                togglePreventReset={() => store.dispatch(convertQuotePreventReset(false))}
                                location={location}
                              />
                            </DocTitleComponent>
                          );
                        }}
                      />
                      <AuthRoute
                        exact={true}
                        allowedRoles={[Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting()]}
                        path={RouteDefinitions.contract2.Create}
                        render={props => {
                          return (
                            <DocTitleComponent title={RouteDefinitions.contract2.Title}>
                              <AsyncContract2
                                resetContract={(clearPropertyInfo: boolean) =>
                                  store.dispatch(resetContract(clearPropertyInfo))
                                }
                                loadContractInfo={(contractId: number | string) => {
                                  store.dispatch(cloneContract(contractId));
                                }}
                                history={props.history}
                                preventReset={store.getState().quote.preventReset}
                                togglePreventReset={() => store.dispatch(convertQuotePreventReset(false))}
                                location={location}
                              />
                            </DocTitleComponent>
                          );
                        }}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.contract.Details}
                        title={RouteDefinitions.contract.Title}
                        component={AsyncContractDetails}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.contract.Balances}
                        title={RouteDefinitions.contract.Title}
                        component={AsyncContractBalances}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, Roles.IBSManager, Roles.IBSAdmin, ...Role.GetAllAccounting()]}
                        exact={true}
                        path={RouteDefinitions.contract.Transfer}
                        title={RouteDefinitions.contract.Title}
                        component={AsyncContractTransfer}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, Roles.IBSManager, Roles.IBSAdmin]}
                        exact={true}
                        path={RouteDefinitions.contract.Search}
                        title={RouteDefinitions.contract.Title}
                        component={ContractSearch}
                      />
                      <TitleRoute
                        path={RouteDefinitions.cilNotification.Notification}
                        title={RouteDefinitions.cilNotification.Title}
                        component={CILNotification}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.version}
                        component={Version}
                      />
                      <TitleRoute exact={true} path={RouteDefinitions.autoautho} component={AutoAutho} />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllAccounting()]}
                        exact={true}
                        path={RouteDefinitions.quote.Create}
                        title={RouteDefinitions.quote.Title}
                        component={AsyncQuote}
                      />
                      {/* Leave as synchronous since its on dashboard */}
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.quote.Search}
                        title={RouteDefinitions.quote.Title}
                        component={QuoteSearch}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.quote.Details}
                        title={RouteDefinitions.quote.Title}
                        component={AsyncQuoteDetails}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, Roles.IBSAdmin]}
                        exact={true}
                        path={RouteDefinitions.contract.Cancellation}
                        title={RouteDefinitions.contract.Title}
                        component={AsyncContractCancellation}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllIBS()]}
                        exact={true}
                        path={RouteDefinitions.contract.OrderEdit}
                        title={RouteDefinitions.contract.Title}
                        component={AsyncOrderEdit}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllIBS()]}
                        exact={true}
                        path={RouteDefinitions.propertymanagementoffice.Edit}
                        title={RouteDefinitions.propertymanagementoffice.Title}
                        component={AsyncPropertyManagementOffice}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.propertymanagementoffice.Details}
                        title={RouteDefinitions.propertymanagementoffice.Title}
                        component={AsyncPropertyManagementOfficeDetails}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.propertymanagementoffice.Search}
                        title={RouteDefinitions.propertymanagementoffice.Title}
                        component={AsyncPropertyManagementOfficeSearch}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllService()]}
                        exact={true}
                        path={RouteDefinitions.vendor.Edit}
                        title={RouteDefinitions.vendor.Title}
                        component={VendorEdit}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllIBS(), ...Role.GetAllService()]}
                        exact={true}
                        path={RouteDefinitions.vendor.Create}
                        title={RouteDefinitions.vendor.Title}
                        component={VendorCreate}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.vendor.Details}
                        title={RouteDefinitions.vendor.Title}
                        component={VendorDetails}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.vendor.Search}
                        title={RouteDefinitions.vendor.Title}
                        component={VendorDashboard}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.vendor.TradeMaintenace}
                        title={RouteDefinitions.vendor.Title}
                        component={VendorTradeMaintenance}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.vendor.PriceAgreements}
                        title={RouteDefinitions.vendor.Title}
                        component={VendorDetails}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.vendor.VQAs}
                        title={RouteDefinitions.vendor.Title}
                        component={VendorDetails}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.vendor.Rerating}
                        title={RouteDefinitions.vendor.Title}
                        component={VendorDetails}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.vendor.Groups}
                        title={RouteDefinitions.vendor.Title}
                        component={VendorDetails}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.renewal.NoChanges}
                        title={RouteDefinitions.renewal.Title}
                        component={AsyncRenewalNoChanges}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.renewal.WithChanges}
                        title={RouteDefinitions.renewal.Title}
                        component={AsyncRenewalWithChanges}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.contract.RenewalOptions}
                        title={RouteDefinitions.contract.Title}
                        component={RenewalOptions}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.serviceworkorder.Edit}
                        title={RouteDefinitions.serviceworkorder.Title}
                        component={AsyncServiceWorkOrder}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.serviceworkorder.Search}
                        title={RouteDefinitions.serviceworkorder.Title}
                        component={AsyncServiceWorkOrderSearch}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.serviceworkorder.Details}
                        title={RouteDefinitions.serviceworkorder.Title}
                        component={AsyncServiceWorkOrderDetails}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.serviceworkorder.Payment}
                        title={RouteDefinitions.serviceworkorder.Title}
                        component={ServiceFeePayment}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.dispatch.Landing}
                        title={RouteDefinitions.dispatch.Title}
                        component={AsyncDispatchLanding}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.zerovendor.Landing}
                        title={RouteDefinitions.zerovendor.Title}
                        component={AsyncZeroVendorLanding}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.authorization.Search}
                        title={RouteDefinitions.authorization.Title}
                        component={AsyncAuthorizationSearch}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.authorization.Details}
                        title={RouteDefinitions.authorization.Title}
                        component={AsyncAuthorizationDetails}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.authorizationVersion.Details}
                        title={RouteDefinitions.authorizationVersion.Title}
                        component={AsyncAuthorizationDetails}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.authorization.ManageInventory}
                        title={RouteDefinitions.authorization.Title}
                        component={AsyncAuthorizationManageInventory}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllAccounting()]}
                        exact={true}
                        path={RouteDefinitions.invoicing.Search}
                        title={RouteDefinitions.invoicing.Title}
                        component={AsyncInvoicingSearch}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllAccounting()]}
                        exact={true}
                        path={RouteDefinitions.invoicing.Create}
                        title={RouteDefinitions.invoicing.Title}
                        component={AsyncInvoiceHeaderCreate}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllAccounting()]}
                        exact={true}
                        path={RouteDefinitions.invoicing.Create}
                        title={RouteDefinitions.invoicing.Title}
                        component={AsyncInvoiceCreate}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllAccounting()]}
                        exact={true}
                        path={RouteDefinitions.invoicing.Edit}
                        title={RouteDefinitions.invoicing.Title}
                        component={AsyncInvoiceCreate}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllAccounting()]}
                        exact={true}
                        path={RouteDefinitions.invoicing.Details}
                        title={RouteDefinitions.invoicing.Title}
                        component={AsyncInvoiceDetails}
                      />
                      <TitleRoute
                        allowedRoles={[Roles.Admin, ...Role.GetAllIBS()]}
                        exact={true}
                        path={RouteDefinitions.contract.NoRenew}
                        title={RouteDefinitions.contract.Title}
                        component={AsyncContractNoRenew}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.contract.Swo}
                        title={RouteDefinitions.contract.Title}
                        component={AsyncServiceWorkOrder}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.purchasing.Search}
                        title={RouteDefinitions.purchasing.Title}
                        component={AsyncPurchasingSearch}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.purchasing.Details}
                        title={RouteDefinitions.purchasing.Title}
                        component={AsyncPurchasingDetails}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.accounting.List}
                        title={RouteDefinitions.accounting.Title}
                        component={AccountingList}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.help.Details}
                        title={RouteDefinitions.help.Title}
                        component={Help}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.transaction.TransactionLanding}
                        title={RouteDefinitions.transaction.Title}
                        component={AsyncTransactionLanding}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.contract.Emails}
                        title={RouteDefinitions.contract.Title}
                        component={AsyncContractEmail}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.contract.PaymentEdit}
                        title={RouteDefinitions.contract.Title}
                        component={AsyncPaymentEdit}
                      />
                      <TitleRoute
                        allowedRoles={Role.GetAll()}
                        exact={true}
                        path={RouteDefinitions.cil.Search}
                        title={RouteDefinitions.cil.Title}
                        component={AsyncCilOfferSearch}
                      />
                      <TitleRoute path="/NotFound" component={NotFoundComponent} />
                      <Redirect from="*" to="/NotFound" />
                    </Switch>
                  </CSSTransition>
                </TransitionGroup>
              )}
            />
            {config.environment === 'Development' ? (
              <TitleRoute exact={true} path={RouteDefinitions.tableofcontents} component={TableOfContents} />
            ) : (
              ''
            )}
          </Layout>
        </div>
      );
    }

    return (
      <>
        <Layout>
          <Route
            render={({ location }) => (
              <TransitionGroup>
                <CSSTransition key={location.key} classNames="fade" timeout={350}>
                  <Switch location={location}>
                    <TitleRoute exact={true} path={RouteDefinitions.login} component={Login} title="Login" />
                    <Route
                      path={RouteDefinitions.cilNotification.Notification}
                      title={RouteDefinitions.cilNotification.Title}
                      component={CILNotification}
                    />
                    <Route exact={true} path={RouteDefinitions.autoautho} component={AutoAutho} />
                    <Route
                      exact={true}
                      path={RouteDefinitions.tutorial.AutoAuthoTutorial}
                      title={RouteDefinitions.tutorial.Title}
                      component={AutoAuthoTutorial}
                    />
                    <Route
                      exact={true}
                      path={RouteDefinitions.tutorial.SWOStatusTutorial}
                      title={RouteDefinitions.tutorial.Title}
                      component={SWOStatusTutorial}
                    />
                    <Route
                      component={() => {
                        return location && <Redirect from="*" to="/login" />;
                      }}
                    />
                  </Switch>
                </CSSTransition>
              </TransitionGroup>
            )}
          />
        </Layout>
      </>
    );
  }
}

export default hot(module)(App);



// WEBPACK FOOTER //
// ./src/App/App.tsx